import { render, staticRenderFns } from "./otherreport.vue?vue&type=template&id=189f0446&scoped=true&"
import script from "./otherreport.vue?vue&type=script&lang=js&"
export * from "./otherreport.vue?vue&type=script&lang=js&"
import style1 from "./otherreport.vue?vue&type=style&index=1&id=189f0446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f0446",
  null
  
)

export default component.exports